import ScrollFadeIn from "@/components/shared/animations/ScrollFadeIn";
import { useTranslations } from "next-intl"
import Image from "next/image";

const WhyUs = () => {

    const t = useTranslations("Home.whyUs.features")

    const aboutUsFeatures = [
        {
            img: "/whyus/dumbbell.png",
            title: t('fitness-services.title'),
            subTitle: t('fitness-services.subTitle')
        },
        {
            img: "/whyus/book.png",
            title: t('diet.title'),
            subTitle: t('diet.subTitle')
        },
        {
            img: "/whyus/smartwatch.png",
            title: t('tracking.title'),
            subTitle: t('tracking.subTitle')
        },
        {
            img: "/whyus/shoes.png",
            title: t('sports.title'),
            subTitle: t('sports.subTitle')
        },
        {
            img: "/whyus/goal.png",
            title: t('activities.title'),
            subTitle: t('activities.subTitle')
        },
        {
            img: "/whyus/stethoscope.png",
            title: t('online-tracking.title'),
            subTitle: t('online-tracking.subTitle')
        }
    ]


    return (
        <div className="w-full max-w-7xl mx-auto px-4">
            <ScrollFadeIn>
                <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
                    {aboutUsFeatures.map((fea, index) => {
                        // For the last two items, add specific classes to center them in a row
                        const isLastTwo = index >= aboutUsFeatures.length - 2;
                        const lastTwoClasses = isLastTwo ? 'lg:col-span-2' : '';

                        return (
                            <div key={index}
                                className={`w-fit flex flex-col gap-4 items-center justify-center text-center 
                            hover:scale-105 hover:shadow-xl p-4 duration-300 
                            ${isLastTwo ? `lg:col-start-${((index % 4) * 2) + 1}` : ''} 
                            ${lastTwoClasses}`}
                            >
                                <div className="">
                                    <Image
                                        src={fea.img}
                                        alt={fea.title}
                                        loading="lazy"
                                        width={60}
                                        height={60}
                                    />
                                </div>

                                <h3 className="font-semibold text-xl">
                                    {fea.title}
                                </h3>

                                <p className="text-[#5E6282] text-[15px] font-normal">
                                    {fea.subTitle}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </ScrollFadeIn>
        </div>
    );
}

export default WhyUs